import React from "react";

import AdminEspeciales from "./AdminEspeciales";

function AdminMarketing({
  modoEdicionMkt,
  handleCancelarEdicionMarketing,
  tipoMkt,
  setTipoMkt,
  tituloMkt,
  setTituloMkt,
  subtituloMkt,
  setSubtituloMkt,
  turnoMkt = "auto",
  setTurnoMkt,
  promoIdMkt,
  setPromoIdMkt,
  productoIdMkt,
  setProductoIdMkt,
  mostrarBotonMkt,
  setMostrarBotonMkt,
  textoBotonMkt,
  setTextoBotonMkt,
  infoAdicionalMkt,
  setInfoAdicionalMkt,
  productos = [],
  promociones = [],
  setArchivoMarketing,
  handleMarketingSubmit,
  cargandoMkt,
  banners,
  especiales,
  handleEditarMarketing,
  handleEliminarMarketing,
}) {
  const [busquedaPlatillo, setBusquedaPlatillo] = React.useState("");

  const productosFiltradosParaEspecial = React.useMemo(() => {
    const texto = busquedaPlatillo.toLowerCase().trim();
    if (!texto) return productos;
    return productos.filter(
      (p) =>
        (p.nombre || "").toLowerCase().includes(texto) ||
        (p.seccion || "").toLowerCase().includes(texto),
    );
  }, [productos, busquedaPlatillo]);

  const platilloSeleccionadoActual = React.useMemo(() => {
    return productos.find((p) => p.id === productoIdMkt);
  }, [productos, productoIdMkt]);
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "16px",
        border: "1px solid #e2e2e2",
      }}
    >
      <h3
        style={{
          margin: "0 0 5px 0",
          fontSize: "18px",
          fontWeight: "700",
          color: "#FF9900",
        }}
      >
        📣 Marketing Visual
      </h3>

      <form
        onSubmit={handleMarketingSubmit}
        style={{
          border: "1px solid #eee",
          padding: "16px",
          borderRadius: "12px",
          backgroundColor: "#fafafa",
        }}
      >
        {modoEdicionMkt && (
          <div
            style={{
              marginBottom: "12px",
              padding: "10px 12px",
              borderRadius: "10px",
              backgroundColor: "#fff7e6",
              border: "1px solid #ffe0b2",
              color: "#8a4b00",
              fontSize: "13px",
              fontWeight: "700",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span>✏️ Editando publicación</span>

            <button
              type="button"
              onClick={handleCancelarEdicionMarketing}
              style={{
                border: "none",
                backgroundColor: "#111",
                color: "#fff",
                padding: "8px 10px",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "800",
                fontSize: "12px",
              }}
            >
              Cancelar
            </button>
          </div>
        )}

        <div
          style={{
            marginBottom: "12px",
          }}
        >
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "700",
              marginBottom: "4px",
            }}
          >
            Tipo:
          </label>

          <select
            value={tipoMkt}
            onChange={(e) => setTipoMkt(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          >
            <option value="banner">🎞️ Banner</option>

            <option value="especial">🌟 Especial</option>
          </select>
        </div>

        {tipoMkt === "especial" && (
          <div
            style={{
              marginBottom: "12px",
            }}
          >
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "700",
                marginBottom: "4px",
              }}
            >
              Turno en el que debe mostrarse:
            </label>

            <select
              value={turnoMkt}
              onChange={(e) => setTurnoMkt && setTurnoMkt(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
              }}
            >
              <option value="auto">
                ⚡ Auto (según el platillo vinculado)
              </option>
              <option value="matutino">🌅 Solo Matutino (Desayunos)</option>
              <option value="vespertino">
                🌌 Solo Vespertino (Comida / Cena)
              </option>
              <option value="todos">☀️/🌙 Todo el día (Ambos turnos)</option>
            </select>
          </div>
        )}

        <div
          style={{
            marginBottom: "12px",
          }}
        >
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "700",
              marginBottom: "4px",
            }}
          >
            Título:
          </label>

          <input
            type="text"
            value={tituloMkt}
            onChange={(e) => setTituloMkt(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <div
          style={{
            marginBottom: "12px",
          }}
        >
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "700",
              marginBottom: "4px",
            }}
          >
            Mensaje:
          </label>

          <input
            type="text"
            value={subtituloMkt}
            onChange={(e) => setSubtituloMkt(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
        </div>

        {tipoMkt === "especial" && (
          <>
            <div
              style={{
                marginBottom: "16px",
                backgroundColor: "#fff",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #e2e2e2",
              }}
            >
              <label
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: "700",
                  marginBottom: "6px",
                  color: "#222",
                }}
              >
                Asociar a Platillo existente (opcional):
              </label>

              {/* Indicador de platillo actualmente seleccionado */}
              {platilloSeleccionadoActual ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px 12px",
                    backgroundColor: "#e8f5e9",
                    border: "1px solid #c8e6c9",
                    borderRadius: "6px",
                    marginBottom: "8px",
                    fontSize: "13px",
                    color: "#2e7d32",
                    fontWeight: "600",
                  }}
                >
                  <span>
                    ✅ <strong>{platilloSeleccionadoActual.nombre}</strong> ($
                    {platilloSeleccionadoActual.precio})
                  </span>
                  <button
                    type="button"
                    onClick={() => setProductoIdMkt("")}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#c62828",
                      cursor: "pointer",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    Quitar ✕
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#777",
                    marginBottom: "8px",
                  }}
                >
                  ℹ️ Ningún platillo seleccionado (se guardará como especial
                  informativo).
                </div>
              )}

              {/* Input buscador */}
              <input
                type="text"
                placeholder="🔍 Escribe para buscar platillo por nombre o categoría..."
                value={busquedaPlatillo}
                onChange={(e) => setBusquedaPlatillo(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  fontSize: "13px",
                  marginBottom: "8px",
                  boxSizing: "border-box",
                }}
              />

              {/* Selector con lista filtrada en vivo */}
              <select
                value={productoIdMkt}
                onChange={(e) => setProductoIdMkt(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  backgroundColor: "#fff",
                  fontSize: "13px",
                }}
              >
                <option value="">
                  -- Seleccionar platillo (
                  {productosFiltradosParaEspecial.length} disponibles) --
                </option>
                {productosFiltradosParaEspecial.map((prod) => (
                  <option key={prod.id} value={prod.id}>
                    {prod.nombre} - ${prod.precio}{" "}
                    {prod.seccion ? `[${prod.seccion}]` : ""}
                  </option>
                ))}
              </select>
            </div>

            {!productoIdMkt && (
              <div style={{ marginBottom: "12px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "13px",
                    fontWeight: "700",
                    marginBottom: "4px",
                  }}
                >
                  Información adicional para la ventana emergente (opcional):
                </label>
                <textarea
                  rows={4}
                  value={infoAdicionalMkt}
                  onChange={(e) => setInfoAdicionalMkt(e.target.value)}
                  placeholder="Escribe detalles adicionales, fecha de inauguración, nuevo menú, o lo que quieras mostrar al abrir el aviso..."
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "13px",
                    boxSizing: "border-box",
                    fontFamily: "inherit",
                  }}
                />
              </div>
            )}

            <div
              style={{
                marginBottom: "12px",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={mostrarBotonMkt}
                  onChange={(e) => setMostrarBotonMkt(e.target.checked)}
                />
                Mostrar botón de acción en la tarjeta
              </label>
            </div>

            {mostrarBotonMkt && (
              <div
                style={{
                  marginBottom: "12px",
                }}
              >
                <label
                  style={{
                    display: "block",
                    fontSize: "13px",
                    fontWeight: "700",
                    marginBottom: "4px",
                  }}
                >
                  Texto del botón:
                </label>

                <input
                  type="text"
                  value={textoBotonMkt}
                  onChange={(e) => setTextoBotonMkt(e.target.value)}
                  placeholder="Ej. TOCA PARA PEDIR → o MÁS INFORMACIÓN →"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            )}

            <div
              style={{
                marginBottom: "12px",
              }}
            >
              <label
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: "700",
                  marginBottom: "4px",
                }}
              >
                Promoción vinculada (opcional):
              </label>

              <select
                value={promoIdMkt}
                onChange={(e) => setPromoIdMkt(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="">Sin promoción</option>

                {promociones.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.tipo}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}

        <div
          style={{
            marginBottom: "16px",
          }}
        >
          <input
            type="file"
            accept="image/*,video/*"
            onChange={(e) => setArchivoMarketing(e.target.files[0])}
          />
        </div>

        <button
          type="submit"
          disabled={cargandoMkt}
          style={{
            width: "100%",
            backgroundColor: "#FF9900",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "12px",
            fontSize: "15px",
            fontWeight: "700",
          }}
        >
          {cargandoMkt ? "Subiendo..." : "Publicar"}
        </button>
      </form>

      <h4
        style={{
          marginTop: "25px",
          marginBottom: "10px",
          fontSize: "15px",
          fontWeight: "700",
        }}
      >
        🎞️ Banners
      </h4>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginBottom: "24px",
        }}
      >
        {banners.map((b) => (
          <div
            key={b.id}
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              padding: "10px",
              border: "1px solid #eee",
              borderRadius: "12px",
            }}
          >
            <img
              src={b.url}
              alt=""
              loading="lazy"
              decoding="async"
              style={{
                width: "58px",
                height: "40px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />

            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: "900",
                }}
              >
                {b.titulo}
              </div>

              <div
                style={{
                  fontSize: "12px",
                  color: "#666",
                }}
              >
                {b.subtitulo}
              </div>
            </div>

            <button
              type="button"
              onClick={() => handleEditarMarketing(b, "marketing")}
            >
              Editar
            </button>

            <button
              type="button"
              onClick={() => handleEliminarMarketing(b.id, "marketing")}
            >
              Borrar
            </button>
          </div>
        ))}
      </div>

      <AdminEspeciales
        especiales={especiales}
        handleEditarMarketing={handleEditarMarketing}
        handleEliminarMarketing={handleEliminarMarketing}
      />
    </div>
  );
}

export default AdminMarketing;
